/**
 * Notifications (spec §9.13): Browser Notifications when granted, else an in-app toast. Permission is
 * asked only when the first reminder is created (§9.24). Nothing here is modal; every toast lives
 * at least 8 s (§9.19).
 */
import { useToasts, type Toast } from "../ui/toasts";

export function canNotify(): boolean {
  return typeof Notification !== "undefined" && Notification.permission === "granted";
}

export async function askNotificationPermission(): Promise<boolean> {
  if (typeof Notification === "undefined") return false;
  if (Notification.permission === "granted") return true;
  if (Notification.permission === "denied") return false;
  return (await Notification.requestPermission()) === "granted";
}

export function notify(
  text: string,
  opts: { action?: Toast["action"]; ms?: number; tag?: string } = {},
): void {
  useToasts.getState().push(text, { action: opts.action, ms: opts.ms });
  if (canNotify() && document.visibilityState !== "visible") {
    try {
      new Notification("Drang", { body: text, tag: opts.tag, silent: true });
    } catch {
      /* some browsers only allow notifications from a service worker */
    }
  }
}
